var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResponsibility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 8.00004C14.6666 4.32004 11.6799 1.33337 7.99992 1.33337C4.31992 1.33337 1.33325 4.32004 1.33325 8.00004C1.33325 11.68 4.31992 14.6667 7.99992 14.6667",
    stroke: "#173D33",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33324 2H5.9999C4.6999 5.89333 4.6999 10.1067 5.9999 14H5.33324",
    stroke: "#173D33",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 2C10.6467 3.94667 10.9733 5.97333 10.9733 8",
    stroke: "#173D33",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 10.6667V10C3.94667 10.6467 5.97333 10.9733 8 10.9733",
    stroke: "#173D33",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 5.99978C5.89333 4.69978 10.1067 4.69978 14 5.99978",
    stroke: "#173D33",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8068 10.4933L10.4468 12.8534C10.3534 12.9467 10.2668 13.12 10.2468 13.2467L10.1201 14.1467C10.0734 14.4733 10.3001 14.7 10.6268 14.6533L11.5268 14.5267C11.6534 14.5067 11.8334 14.42 11.9201 14.3267L14.2801 11.9667C14.6868 11.56 14.8801 11.0867 14.2801 10.4867C13.6868 9.89334 13.2134 10.0867 12.8068 10.4933Z",
    stroke: "#173D33",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4668 10.8334C12.6668 11.5534 13.2268 12.1134 13.9468 12.3134",
    stroke: "#173D33",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponsibility);
export default __webpack_public_path__ + "static/media/responsibility.1c83116edc615bb57d0bac9f576d4e14.svg";
export { ForwardRef as ReactComponent };